import { Box, Modal, Typography, styled, Button } from "@mui/material"
import { ModalCard } from "../UnassignModal/UnassignModal.styles"

const ModalHeader = styled(Typography)({
  fontWeight: 400,
  fontSize: 24,
  lineHeight: "32px",
  color: "var(--black)",
})

const ModalSubheader = styled(Typography)({
  fontWeight: 400,
  fontSize: 16,
  lineHeight: "24px",
  letterSpacing: 0.5,
  color: "var(--black)",
})

export default function DeleteModal({
  open,
  onCancel,
  onDelete,
  header,
  subheader,
}: {
  open: boolean
  onCancel: () => void
  onDelete: () => void
  header: string
  subheader: string
}) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      aria-labelledby="delete-team-modal-header"
      aria-describedby="delete-team-modal-subheader"
    >
      <ModalCard>
        <ModalHeader id="delete-team-modal-header">{header}</ModalHeader>

        <ModalSubheader id="delete-team-modal-subheader">
          {subheader}
        </ModalSubheader>

        <Box sx={{ display: "flex", alignSelf: "flex-end", gap: "11px" }}>
          <Button
              variant="outlined"
              onClick={onCancel}
          >
              Cancel
          </Button>
          <Button
              variant="contained"
              onClick={onDelete}
          >
              Delete
          </Button>
        </Box>
      </ModalCard>
    </Modal>
  )
}
